import React from 'react';
import classnames from 'classnames';
import styles from './link-list.scss';

export const LinkList = ({ links, Item, className, children }) => (
  <ul className={classnames(styles.list, className)}>
    {links.map(link => (
      <Item
        key={link.name}
        url={link.url}
        external={link.external}
        handler={link.handler}
        menuLinks={link.menuLinks || []}
      >
        {link.name}
      </Item>
    ))}
    {children}
  </ul>
);
